import { render } from "./clubMatches.vue?vue&type=template&id=76b95068&scoped=true"
import script from "./clubMatches.vue?vue&type=script&lang=js"
export * from "./clubMatches.vue?vue&type=script&lang=js"

import "./clubMatches.vue?vue&type=style&index=0&id=76b95068&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b95068"]])

export default __exports__